export const deliveryOutstanding = sale => {
  if (sale.status !== 'LIVRE') return null;
  return Math.max(0, Math.round((Number(sale.montantTotalTTC || 0) - Math.max(0, Number(sale.montantPaye || 0))) * 100) / 100);
};
